<template lang="html">
  <span>
    <v-icon :name="globe" />
  </span>
</template>

<script>
export default {
  name: "WorldIcon",
  props: {
    delay: {
      type: Number,
      default: () => 1500
    }
  },
  data() {
    return {
      current: 0,
      icons: ["globe-africa", "globe-americas", "globe-asia"]
    };
  },
  computed: {
    globe() {
      return this.icons[this.current];
    }
  },
  mounted() {
    setTimeout(this.rotate, this.delay);
  },
  methods: {
    rotate() {
      if (this.current < this.icons.length - 1) {
        this.current++;
      } else {
        this.current = 0;
      }
      setTimeout(this.rotate, this.delay);
    }
  }
};
</script>

<style lang="css" scoped></style>
